import { useEffect } from 'react';

export const useDarkMode = () => {
  useEffect(() => {
    // Remove any data-theme attribute to ensure light mode only
    const html = document.documentElement;
    html.removeAttribute('data-theme');
  }, []);

  return { isDarkMode: false };
};
